/**
 * What to Expect — section behaviors
 * - Smooth-scroll for in-page CTA hashes
 */
(function () {
  function initWhatToExpect(root) {
    if (!root || root.dataset.wteReady === 'true') return;
    root.dataset.wteReady = 'true';

    root.querySelectorAll('a.wte__cta[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-what-to-expect]').forEach(initWhatToExpect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-what-to-expect]').forEach(initWhatToExpect);
  });
})();
